
// Used at list in glist column config
export enum FieldRenderMethod {

    VIEW            = 'view',
    VIEW_SMALL      = 'viewSmall',
    VIEW_REFERENCE  = 'viewReference',

    INLINE_EDITABLE = 'renderInlineEditable',

    GLIST_EDITABLE  = 'glistEditable'

}

export enum FieldAccess {
    NO_ACCESS   = 'no-access',  // at the moment not used but false as value is used
    READ        = 'read',
    WRITE       = 'write'
}

export enum FieldViewSize {
    DEFAULT     = 'default',    // used in views i.e. 14px default font
    SMALL       = 'small',      // used in table, list, etc 13px less important
}
